import { lazy, type LazyExoticComponent, type ComponentType } from 'react'

export interface ModuleDef {
  slug: string
  label: string
  /** Lazy-loaded page component mounted at /:workspaceSlug/:slug/* */
  page: LazyExoticComponent<ComponentType>
}

/**
 * Static registry of optional modules. The Topbar shows a tab for any
 * entry whose slug is also returned in /api/auth/me.modules (i.e.
 * enabled for the current workspace AND globally active). Add a new
 * module by creating its folder under `frontend/src/modules/<slug>/`
 * and pushing an entry here.
 */
export const moduleRegistry: ModuleDef[] = [
  {
    slug: 'bcf',
    label: 'BCF',
    page: lazy(() => import('@modules/bcf')),
  },
  {
    slug: 'ifc-edit',
    label: 'IFCEdit',
    page: lazy(() => import('@modules/ifc-edit')),
  },
  {
    slug: 'boq',
    label: 'BoQ',
    page: lazy(() => import('@modules/boq')),
  },
  {
    slug: 'info-table',
    label: 'Tabela',
    page: lazy(() => import('@modules/info-table')),
  },
  {
    slug: 'ids',
    label: 'IDS',
    page: lazy(() => import('@modules/ids')),
  },
  {
    slug: 'clash',
    label: 'Conflitos',
    page: lazy(() => import('@modules/clash')),
  },
  {
    slug: 'assistant',
    label: 'Assistente',
    page: lazy(() => import('@modules/assistant')),
  },
  {
    slug: 'pdf-review',
    label: 'PDF',
    page: lazy(() => import('@modules/pdf-review')),
  },
]

export function findModule(slug: string): ModuleDef | undefined {
  return moduleRegistry.find((m) => m.slug === slug)
}
